<div class="modal-header modal-save-header px-0">
    <div class="d-flex flex-grow-1">
        <div class="flex-grow-1 justify-content-end">
            <div>
                <h5 class="modal-title text-left">{{'CourtBookingSave.Title' | translate}} </h5>
            </div>
        </div>
        <div class="flex-grow-1 d-flex justify-content-end">
            <button type="button" data-dismiss="modal" aria-label="Close" (click)="bsModalRef.hide()"
                class="btn btn-light-blue-outline btn-sm">{{'CourtBookingSave.CancelButton' | translate}}</button>

            @let formLoadingValue = formLoading();
            <button type="button" (click)="save()" [disabled]="!isFormValid() || formLoadingValue"
                class="btn btn-light-blue btn-sm ml-2">{{'CourtBookingSave.SaveButton' | translate}}
                @if (formLoadingValue) {
                <span class="spinner-border spinner-border-sm"></span>
                }
            </button>
        </div>
    </div>
</div>
<div class="modal-body court-booking-save-body bay-club-light-blue-2-bg">
    <div class="modal-save-content">
        @let showFormSpinnerValue = showFormSpinner();
        @if (showFormSpinnerValue) {
        <bcu-local-spinner [size]="40" [visible]="showFormSpinnerValue">
        </bcu-local-spinner>
        }
        @if (form) {
        <form [formGroup]="form" ngxsForm="cbCourtBookingSave.courtBookingForm">
            <div class="player-add-main">
                <label class="text-uppercase font-weight-bold" translate>CourtBookingSave.AddPlayerLabel</label>
                <app-court-booking-player-search formControlName="firstPlayer" [playerRules]="firstPlayerRules()">
                </app-court-booking-player-search>
            </div>
            <div class="booking-save-details">
                <app-court-booking-save-details [formLoaded]="formLoaded" [form]="form"
                    [isMainPlayerSelected]="isMainPlayerSelected()" [courtBookingInput]="courtBookingInput">
                </app-court-booking-save-details>
            </div>
            <div>
                <app-court-booking-save-players [form]="form"></app-court-booking-save-players>
            </div>
        </form>
        }

    </div>

</div>